import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function relatedCard({ item }) {
  return (
    <>
      <div className="blog-card ">
           <div className="blog-card-image">
             <Link to={`/blog/${item?.slug}`}>
               <img className="rounded-2"src={item?.image} alt={item?.title} />
             </Link>
           </div>
     
           <div className="blog-card-body">
             <div className="blog-meta">
               {item?.date && <span>{getDateAgo(item?.date)}</span>}
               {item?.author && <span>{item?.author}</span>}
             </div>
     
             <Link to={`/blog/${item?.slug}`} className="blog-title">
               {item?.title}
             </Link>
     
             <p className="blog-desc">
               {item?.shortDescription}
             </p>
     
             <Link to={`/blog/${item?.slug}`} className="blog-btn">
               Read More →
             </Link>
           </div>
         </div>
    </>
  );
}

export default relatedCard;
